export default __webpack_public_path__ + "static/media/8p.c2c2fa61.svg";